<template>
    <div class="password-validation-wrapper">
        <b-tooltip
                custom-class="password-validation-tooltip text-left d-none d-lg-block"
                :show="showTooltip && visible"
                placement="right"
                :target="target"
                triggers=""
        >
            <div>
                <b-row
                        v-for="(validation) in passwordValidations"
                        :key="validation.index"
                >
                    <b-col
                            cols="1"
                            class="text-center"
                    >
                        <i
                                class="fas fa-check text-success"
                                v-if="validation.validationMethod(password)"
                        />
                        <i
                                class="fas fa-times text-danger"
                                v-else
                        />
                    </b-col>
                    <b-col class="text-left">
                        {{ validation.text }}
                    </b-col>
                </b-row>
            </div>
        </b-tooltip>
        <div
                class="password-validation-info d-lg-none"
                :v-if="showTooltip && visible"
        >
            <b-row
                    v-for="(validation) in passwordValidations"
                    :key="validation.index"
            >
                <b-col
                        cols="1"
                        class="text-center"
                >
                    <i
                            class="fas fa-check text-success"
                            v-if="validation.validationMethod(password)"
                    />
                    <i
                            class="fas fa-times text-danger"
                            v-else
                    />
                </b-col>
                <b-col class="text-left">
                    {{ validation.text }}
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import {passwordValidations} from '@milestoneslabs/milestones-ui-kit/src/helpers/messages';

export default {
    name: 'PasswordValidation',
    props: {
        password: {
            type: String,
            required: true,
        },
        target: {
            type: String,
            required: true,
        },
        visible: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            passwordValidations,
            showTooltip: true,
        };
    },

    watch: {
        password(value) {
            let isValid = this.passwordValidations.filter((validation) => {
                return validation.validationMethod(value) === false;
            }).length === 0;

            this.showTooltip = !isValid;
        }
    }
};
</script>

<style lang="scss">
.password-validation-wrapper {
    flex-wrap: wrap;
    width: 100%;
    padding-top: 10px;
}

.password-validation-tooltip {
    .tooltip-inner {
        max-width: 16.5rem !important;
        width: 16.5rem;
    }

    .fa-check {
        font-size: 0.65rem;
    }

    .fa-times {
        font-size: 0.85rem;
    }
}
</style>
